import { ReactNode, useState } from "react";
import {
  PopoverContent,
  PopoverPortal,
  PopoverTrigger,
  Root,
} from "@radix-ui/react-popover";
import { TTag } from "screens/DApps/types";
import { Plus } from "assets/icons/Plus";
import clsx from "clsx";

type TProps = {
  availableTags: TTag[];
  selectedTags: TTag[];
  onTagClick: (tag: TTag) => void;
  children: ReactNode;
};

export const TagsDropdown = ({
  children,
  availableTags,
  onTagClick,
  selectedTags,
}: TProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const stopPropagation = (e: React.MouseEvent<Element, MouseEvent>) => {
    e.stopPropagation();
  };

  const isTagSelected = (tag: TTag) => {
    return selectedTags.some((t) => t.id === tag.id);
  };

  return (
    <Root open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverPortal>
        <PopoverContent asChild className="bg-[#111111] w-[406px] z-[10]">
          <div
            className="overflow-auto custom-scrollbar max-h-[300px]"
            onClick={stopPropagation}
          >
            {availableTags.map((tag) => (
              <div
                className={clsx(
                  "p-2 flex gap-4 items-center hover:bg-[#FFFFFF1A] cursor-pointer hover:text-[#FFC93D]",
                  isTagSelected(tag) && "text-[#FFC93D]"
                )}
                key={tag.id}
                onClick={() => onTagClick(tag)}
              >
                {tag.name}
                {isTagSelected(tag) ? (
                  <span className="ml-auto mr-0.5 text-[24px] leading-[10px]">
                    -
                  </span>
                ) : (
                  <Plus className="ml-auto" />
                )}
              </div>
            ))}
          </div>
        </PopoverContent>
      </PopoverPortal>
    </Root>
  );
};
